import React from 'react'
import { ExchangersList } from './list/page'
export const ExchangersPage = (): JSX.Element => {
  return <ExchangersList />
}
